
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Refonte de site Internet : la solution ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Pourquoi et comment effectuer la refonte de son site Web ? Combien ça coûte ? Pourquoi le faire avec une agence de communication ? Cet article vous explique tout !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Refonte de site Internet : la solution ALEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Pourquoi et comment effectuer la refonte de son site Web ? Combien ça coûte ? Pourquoi le faire avec une agence de communication ? Cet article vous explique tout !",
        },
      ],
    };
  },
};
